import { c as _c } from "react/compiler-runtime";
import type { CreateWaveOutcomeType } from "@/types/waves.types";
export default function CreateWaveOutcomeTypesItem(t0) {
  const $ = _c(15);
  const {
    outcomeType,
    label,
    selectedOutcomeType,
    setOutcomeType
  } = t0;
  const isActive = selectedOutcomeType === outcomeType;
  const classes = isActive ? "tw-border-primary-400 tw-bg-primary-500/5 tw-ring-primary-400 tw-ring-primary-500/30 tw-text-white" : "tw-border-white/5 tw-bg-iron-900 tw-ring-white/5 tw-text-iron-300 hover:tw-border-white/10 hover:tw-bg-iron-800 hover:tw-text-white hover:tw-ring-white/10";
  let t1;
  if ($[0] !== outcomeType || $[1] !== setOutcomeType) {
    t1 = () => setOutcomeType(outcomeType);
    $[0] = outcomeType;
    $[1] = setOutcomeType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `${classes} tw-group tw-relative tw-flex tw-min-h-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-xl tw-border tw-border-solid tw-px-3 tw-py-3 tw-text-sm tw-font-semibold tw-shadow-inner tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none`;
  const t3 = `tw-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-transition tw-duration-300 tw-ease-out ${isActive ? "tw-border-primary-400 tw-bg-primary-500/10" : "tw-border-iron-600 tw-bg-transparent group-hover:tw-border-iron-500"}`;
  const t4 = `tw-h-2 tw-w-2 tw-rounded-full tw-bg-primary-400 tw-transition tw-duration-200 ${isActive ? "tw-scale-100" : "tw-scale-0"}`;
  let t5;
  if ($[3] !== t4) {
    t5 = <span className={t4} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <span aria-hidden="true" className={t3}>{t5}</span>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== label) {
    t7 = <span className="tw-min-w-0 tw-truncate">{label}</span>;
    $[8] = label;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t6 || $[13] !== t7) {
    t8 = <button onClick={t1} type="button" className={t2}>{t6}{t7}</button>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}